import { contentfulClient } from "./contentfulClient";

// turn Contentful rich text JSON into a short plain string
function richTextToPlain(rt) {
  try {
    if (!rt || !rt.content) return "";
    const out = [];
    (function walk(n) {
      if (!n) return;
      if (n.nodeType === "text" && typeof n.value === "string")
        out.push(n.value);
      if (Array.isArray(n.content)) n.content.forEach(walk);
    })(rt);
    return out.join(" ").replace(/\s+/g, " ").trim();
  } catch {
    return "";
  }
}

function fileUrl(asset) {
  const u = asset?.fields?.file?.url || "";
  if (!u) return "";
  return u.startsWith("//") ? "https:" + u : u;
}

export async function getCharactersForLobby({ playableOnly = true } = {}) {
  const res = await contentfulClient.getEntries({
    content_type: "murderMysteryCharacter",
    order: "fields.characterTitle",
    include: 2, // pull linked assets like images
    limit: 1000,
  });

  const items = (res.items || []).map((e) => {
    const f = e.fields || {};

    // "playable" flags you were already using
    const playable = !!f.abilityKey || f.playable === true || !!f.ability;

    // Use your existing field names first; fallback to alternates if present
    const imgAsset =
      f.characterImage || f.image || f.cardImage || f.photo || null;
    const imageUrl = fileUrl(imgAsset);

    // Prefer your rich text field, but keep fallbacks
    const descriptionRich = f.characterDescription || f.descriptionRich || null;
    const descriptionPlain =
      typeof f.description === "string"
        ? f.description
        : f.descriptionPlain || richTextToPlain(descriptionRich);

    return {
      id: e.sys.id,
      title: f.characterTitle,
      team: f.role, // "Camper" | "Villain" | "Unique"
      playable,
      imageUrl,
      descriptionRich, // rich text JSON (for renderRichText)
      description: descriptionPlain, // handy plain-text fallback
    };
  });

  if (!playableOnly) return items;

  const FALLBACK_WHITELIST = new Set([
    "Skater",
    "Jock",
    "Camp Director",
    "Emo",
    "Slasher",
    "Mathlete",
    "Lifeguard",
    "Witch of the Woods",
    "The Shadow",
    "Camp Counselor",
    "The Possessed Camper",
    "Anime Fan",
    "Cheerleader",
    "Groundskeeper",
    "Debate Student",
    "Nurse",
    "Quiet Kid",
    "Chess Player",
    "Punk",
    "Woodland Beast",
    "Prom King",
    "Prom Queen",
    "Hermit",
    "Hipster",
    "Gossip",
    "The Crazed Woodsman",
  ]);

  return items.filter((i) => i.playable || FALLBACK_WHITELIST.has(i.title));
}
